import { render, staticRenderFns } from "./BillboardManage.vue?vue&type=template&id=2514a5ba&scoped=true"
import script from "./BillboardManage.vue?vue&type=script&lang=js"
export * from "./BillboardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514a5ba",
  null
  
)

export default component.exports